import React from "react";
import styled from "styled-components";
import { FadeIn } from "styles/keyFrame/Fade";
import media from "styles/media";

const Title = styled.h1`
  font-family: "Dhurjati", sans-serif;
  font-size: 8rem;
  text-transform: uppercase;
  font-weight: 600;
  text-shadow: 0px 0px 3px ${({ theme }) => theme.shadowColor};
  text-align: center;
  padding: var(--header) 0;

  opacity: 0;
  animation: ${FadeIn} 0.8s linear forwards;

  ${media.xlarge} {
    font-size: 7rem;
  }

  ${media.medium} {
    font-size: 6rem;
  }
  ${media.small} {
    font-size: 4rem;
  }
`;

interface SectionTitleProps {
  title: string;
}

export default function SectionTitle({ title }: SectionTitleProps) {
  return <Title>{title}</Title>;
}
